import CalculatorIcon from '../../../../../icons/calculator.svg?react';
import DollarTagIcon from '../../../../../icons/dollar-tag.svg?react';
import HandSelectClickIcon from '../../../../../icons/hand-select-click.svg?react';
import DocumentIcon from '../../../../../icons/document.svg?react';

export default function PurchasingProcessData() {
    return {
        subtitle: "Covr's Supplemental Insurance Quoter compares options from across the market.",
        image: "/product-landing/hosp/circle1.png",
        title:'The Application Process',
        steps: [
            {
                title: "Select Your Coverage",
                icon: CalculatorIcon,
                paragraphs: [
                    "Choose the supplemental insurance option and additional benefits you'd like to apply for.",
                ]
            },
            {
                title: "Get a Quote",
                icon: DollarTagIcon,
                paragraphs: [
                    "Use the tool above to enter your information and get an instant quote.",
                ]
            },
            {
                title: "The Application Process",
                icon: HandSelectClickIcon,
                paragraphs: [
                    "To start your application, enter your personal information, dependent information, and, if necessary, answer a few medical questions.",
                ]
            },
            {
                title: "Underwriting and Decision",
                icon: DocumentIcon,
                paragraphs: [
                    "Once you submit your application, you'll receive a decision within 1 to 2 days, and coverage will go into effect upon your first premium payment, subject to waiting periods that may apply.",
                ]
            }
        ]
    }
}